
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_37gf8_1b8da_9"
};
  